import { RouteRecordRaw } from '@bv/router';

import { integrationsBreadcrumbs, webhooksBreadcrumbs } from '@/router/main/breadcrumbs';

export const webhooksRoutes: RouteRecordRaw[] = [
  {
    path: 'webhooks',
    meta: {
      breadcrumbs: integrationsBreadcrumbs({
        label: 'integrations.webhooks.title_trans',
        route: { name: 'int-webhooks' },
      }),
    },
    children: [
      {
        path: '',
        name: 'int-webhooks',
        component: () => import('@/components/integrations/web-hook/WebHooks.vue'),
      },
      {
        path: '',
        component: () => import('@/components/integrations/web-hook/WebHooksForm.vue'),
        children: [
          {
            path: 'add',
            name: 'int-webhook-add',
          },
          {
            path: 'edit/:id',
            name: 'int-webhook-edit',
          },
        ] as RouteRecordRaw[],
      },
    ],
  },
  {
    path: 'webhooks/logs',
    name: 'int-webhook-logs',
    redirect: { name: 'int-webhook-logs-list' },
    meta: {
      breadcrumbs: webhooksBreadcrumbs({
        label: 'integrations.webhooks.logs.title_trans',
        route: { name: 'int-webhook-logs-list' },
      }),
    },
    children: [
      {
        path: '',
        name: 'int-webhook-logs-list',
        component: () => import('@/components/integrations/web-hook/webhook-logs/LogList.vue'),
      },
      {
        path: ':logId',
        name: 'int-webhook-logs-view',
        component: () => import('@/components/integrations/web-hook/webhook-logs/LogPreview.vue'),
      },
    ],
  },
];
